const Loading = () => {
  return (
    <div className="loading-container">
      <h1>
        <i className="fa-solid fa-spinner"></i> Loading...
      </h1>
    </div>
  );
};

export default Loading;
